import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/audits/(pages)/(list)/network-audits',
)({
  component: lazyRouteComponent(
    () => import('../../../-components/NetworkAuditsLayout'),
    'NetworkAuditsLayout',
  ),
});
